import React, { useState } from "react";
import { Modal, Upload, Button, Typography } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { importPipeline } from "./SkeyeingestPipelinesAPI";
import { extractMsg, showErrorToast } from "../../../utils/errorUtils";
const { Dragger } = Upload;

export default function SkeyeingestImportPipelineDialog({
  open,
  onClose,
  onSuccess,
  messageApi,
}) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImport = async () => {
    if (!file) {
      messageApi.warning("Please select a JSON file to import.");
      return;
    }
    setLoading(true);
    try {
      const fileContent = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsText(file);
      });
      const response = await importPipeline(JSON.parse(fileContent));
      if (response?.statusCode === 200 || response?.statusCode === 201) {
        messageApi.success("Pipeline imported successfully");
        setFile(null);
        onSuccess();
        onClose();
      }
    } catch (error) {
      showErrorToast(messageApi, error, "Failed to import pipeline");
    } finally {
      setLoading(false);
    }
  };

  const uploadProps = {
    accept: ".json",
    beforeUpload: (f) => {
      if (f.size > 10 * 1024 * 1024) {
        messageApi.error("File size exceeds the 10 MB limit");
        return Upload.LIST_IGNORE;
      }
      setFile(f);
      return false;
    },
    onRemove: () => setFile(null),
    fileList: file ? [file] : [],
    maxCount: 1,
  };

  return (
    <Modal
      title="Import Pipeline"
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
    >
      <Dragger
        {...uploadProps}
        style={{ padding: "20px", marginBottom: "24px" }}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined style={{ color: "#e29b45" }} />
        </p>
        <p className="ant-upload-text">
          Click or drag JSON file to this area to upload
        </p>
        <Typography.Text type="secondary">
          Strictly only accepts valid Datacollector pipeline JSON exports (Max
          10 MB).
        </Typography.Text>
      </Dragger>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <Button
          onClick={onClose}
          disabled={loading}
          style={{ backgroundColor: "#D97A07", color: "#fff", border: "none" }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={handleImport}
          loading={loading}
          style={{ backgroundColor: "#0D2E4D" }}
        >
          Import
        </Button>
      </div>
    </Modal>
  );
}
